export type PasswordRule = {
  id: 'length' | 'letter' | 'digit' | 'match';
  label: string;
  test: (pw: string, confirm: string) => boolean;
};

export const PASSWORD_RULES: PasswordRule[] = [
  {
    id: 'length',
    label: 'Al menos 8 caracteres',
    test: (p) => p.length >= 8,
  },
  {
    id: 'letter',
    label: 'Al menos una letra',
    test: (p) => /[a-zA-Z]/.test(p),
  },
  { id: 'digit', label: 'Al menos un número', test: (p) => /\d/.test(p) },
  {
    id: 'match',
    label: 'Las contraseñas coinciden',
    test: (p, c) => !!p && p === c,
  },
];

export function passwordRulesPass(pw: string, confirm: string): boolean {
  return PASSWORD_RULES.every((r) => r.test(pw, confirm));
}
